import { Injectable } from '@angular/core';
import { webSocket, WebSocketSubject } from 'rxjs/webSocket';
import { environment } from 'src/environments/environment';
import { Observable, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AiAutomationService {
    private socket$: WebSocketSubject<any> | null = null;
    private messagesSubject = new Subject<any>();

    public messages$ = this.messagesSubject.asObservable();

    constructor() { }

    connect(url: string = `ws://${environment.baseUrlAiAutomation}/ws/run`): void {
        this.socket$ = webSocket({
            url: url,
            deserializer: (msg) => JSON.parse(msg.data),
            serializer: (msg) => JSON.stringify(msg)
        });

        this.socket$.subscribe({
            next: (msg) => this.messagesSubject.next(msg),
            error: (err) => {
                console.error('WebSocket Error:', err);
                this.messagesSubject.next({ type: 'error', message: 'Connection lost or failed' });
            },
            complete: () => console.log('WebSocket Connection Closed')
        });
    }

    sendRunMessage(steps: string[], appPackage?: string, appActivity?: string, deviceName?: string, deviceSerial?: string, appiumUrl?: string): void {
        if (!this.socket$) {
            console.error('Socket not connected');
            return;
        }

        const runMsg: any = {
            type: 'run',
            steps: steps
        };

        if (appPackage) runMsg.app_package = appPackage;
        if (appActivity) runMsg.app_activity = appActivity;
        if (deviceName) runMsg.device_name = deviceName;
        if (deviceSerial) runMsg.device_serial = deviceSerial;
        if (appiumUrl) runMsg.appium_url = appiumUrl;

        this.socket$.next(runMsg);
    }

    disconnect(): void {
        if (this.socket$) {
            this.socket$.complete();
            this.socket$ = null;
        }
    }

    async downloadScript(sessionId: string): Promise<Blob> {
        const url = `http://${environment.baseUrlAiAutomation}/generate-script/${sessionId}`;
        const response = await fetch(url, { method: 'POST' });
        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(`Failed to generate script: ${errorText}`);
        }
        return await response.blob();
    }
}
